import React from 'react'

import { ZariContext } from '_zari/context'

import { Form, Col } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablasComunService from 'services/tablasComunes.service'

const TipoOperacionFormGroup = ({ value }) => {
  const __zariContext = React.useContext(ZariContext)
  const [tiposOperacion, setTiposOperacion] = React.useState([])

  React.useEffect(() => {
    TablasComunService.getAsSelect(TiposTablaComunConstant.TIPOOPERACIONSUNAT)
      .then(({ data }) => setTiposOperacion(data))
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext])

  return (
    <Form.Group>
      <Form.Label text='TIPO OPERACION' htmlFor='select-tipoOperacion' md={4} alignRightAt='md' />
      <Col md={8}>
        <Form.Select
          id='select-tipoOperacion'
          name='select-tipoOperacion'
          value={value}
          onChange={() => {}}
          disabled
        >
          <option value=''>Seleccionar</option>
          {tiposOperacion.map((val, key) => (
            <option key={key} value={val._id}>
              {val.nombre}
            </option>
          ))}
        </Form.Select>
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoOperacionFormGroup)
